module.exports = __webpack_public_path__ + "b7392cb4a64bc1308ee4d21adb3755ea.svg";